import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { ResponsiveStyleProps } from "@/lib/craft/style-props";

type ColumnProps = {
  widthPercent: number;
  style?: ResponsiveStyleProps;
};

const WIDTH_PRESETS = [
  { label: "100%", value: 100 },
  { label: "75%", value: 75 },
  { label: "66%", value: 66.67 },
  { label: "50%", value: 50 },
  { label: "33%", value: 33.33 },
  { label: "25%", value: 25 },
];

export function ColumnBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<ColumnProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Column width</Label>
          <Select
            value={String(props.widthPercent ?? 100)}
            onValueChange={(v) => setProp((p) => { p.widthPercent = Number(v); })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              {WIDTH_PRESETS.map((w) => (
                <SelectItem key={w.value} value={String(w.value)}>{w.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
